import Vue from 'vue';

import {
  Loading,
  Message,
  MessageBox,
  Menu,
  Submenu,
  MenuItem,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Tooltip,
  Form,
  FormItem,
  Input,
  InputNumber,
  Row,
  Col,
  Button,
  Table,
  TableColumn,
  Pagination,
  Dialog,
  DatePicker,
  Upload,
  Select,
  Option,
  OptionGroup,
  Image,
  Tag
} from 'element-ui';

Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer);
Vue.use(InputNumber);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Tooltip);
Vue.use(Input);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Row);
Vue.use(Col);
Vue.use(Button);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(DatePicker);
Vue.use(Upload);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Loading);
Vue.use(Image);
Vue.use(Tag);
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;

Vue.prototype.$loading = (options) => {
  const target = '.loading';
  const background = 'rgba(255, 255, 255, 1)';
  const text = '正在查询数据，请稍后...';

  let loadingOptions = null;

  if (typeof options === 'string') {
    loadingOptions = {
      text: options,
      target,
      background,
    };
  } else {
    loadingOptions = {
      text,
      target,
      background,
      ...options,
    };
  }

  return Loading.service(loadingOptions);
};
